import { SmallPaddingCard, IconFont, DeleteModal, SvgIcon, SignTitle } from '@/components'
import styled from 'styled-components'
import { Button, Checkbox, Form, Input, Modal, Typography } from 'antd'
import { Scrollbars } from 'react-custom-scrollbars'
import { GetGroupData } from '@/api/target'
import { useEffect, useMemo, useState } from 'react'
import { useDeleteGroup } from '../../phishing/target/utils'
import { useDebounce, useSelections } from 'ahooks'
import { SearchInputTwo } from '@/components/search-input-two'
import { useDeleteAgentPool, useGetAgentPool, usePostAgentPool, usePutAgentPool } from './utils'
import { t } from '@/i18n'
const { useForm } = Form

interface GroupItemProps {
  activeid: string | undefined
  children: string
  name: string
  typeId: 1 | 2 | undefined
  id: string
  status: number
  onDelete: (id: string) => void | Promise<any>
  onClick: (id: string) => void | Promise<any>
}

interface DelteModal {
  visible: boolean
  deleteid: string[]
}

export interface AgentPool {
  name: string
  pool_id: string
  status: number
}

const ProxyLeft = props => {
  const { play } = props
  const [selectAgentPool, setSelectAgentPool] = useState<AgentPool | undefined>()
  const [searchParams, setSearchParams] = useState<GetGroupData>({
    name: '',
  })
  const [showAddModal, setShowAddModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState({ visible: false, id: null, name: '' })
  let [deleteModal, setDeleteModal] = useState<DelteModal>({
    visible: false,
    deleteId: null,
  })
  const [tipModal, setTipModal] = useState(false)
  const [getAgentPool, agentPoolLoading, agentPoolData] = useGetAgentPool()
  const [postAgentPool, postAgentPoolLoading] = usePostAgentPool()
  const [putAgentPool] = usePutAgentPool()
  const [agentPoolList, getAgentPoolList] = useState<any>()
  const debounceFilterGroupName = useDebounce(searchParams.name, { wait: 500 })
  const [deleteGrouop, deleteGrouopLoading] = useDeleteGroup()
  const [deleteAgentPool] = useDeleteAgentPool()
  const [form] = useForm()
  const confirmDeleteAgentPool = async () => {
    // console.log(deleteModal.deleteId)
    try {
      await deleteAgentPool({ pool_id: deleteModal.deleteId })
        .then(res => unSelectAll())
        .catch(_ => {})
      getAgentPool({})
        .then(res => {
          getAgentPoolList(res.data)
          play(res.data?.items?.[0])
          setSelectAgentPool(res.data?.items?.[0])
        })
        .catch(_ => {})
      setDeleteModal({ visible: false, deleteId: null })
    } catch (error) {
      // console.log(error)
    }
  }
  const groupListKeys = useMemo(() => {
    let arr = []
    agentPoolList?.items?.map(item => {
      arr.push(item.pool_id)
    })
    return arr
  }, [agentPoolList])
  useEffect(() => {
    getAgentPool({ search: debounceFilterGroupName })
      .then(res => {
        getAgentPoolList(res.data)
        play(res.data?.items?.[0] || [])
        setSelectAgentPool(res.data?.items?.[0] || [])
      })
      .catch(_ => {})
  }, [debounceFilterGroupName])
  const { selected, isSelected, toggle, unSelectAll, selectAll } = useSelections(
    groupListKeys,
    (agentPoolList || [])?.items?.map(item => item?.ID),
  )

  const exit = values => {
    setIsEditGroupName({ visible: false, text: '', id: null })
    if (values) {
      getAgentPool({ type: 3 })
        .then(res => {
          getAgentPoolList(res.data)
        })
        .catch(_ => {})
    }
  }
  const submitHandler = data => {
    if (showEditModal.visible) {
      putAgentPool({ name: data.names, pool_id: showEditModal.id })
        .then(() => {
          setShowEditModal({ name: '', id: null, visible: false })
          form.resetFields()
          getAgentPool({})
            .then(res => {
              getAgentPoolList(res.data)
              play(res.data?.items[0])
              setSelectAgentPool(res.data?.items[0])
            })
            .catch(_ => {})
        })
        .catch(() => {})
    } else {
      postAgentPool({ name: data.names })
        .then(() => {
          setShowAddModal(false)
          form.resetFields()
          getAgentPool({})
            .then(res => {
              getAgentPoolList(res.data)
              play(res.data?.items[0])
              setSelectAgentPool(res.data?.items[0])
            })
            .catch(_ => {})
        })
        .catch(_ => {})
    }
  }
  const [isEditGroupName, setIsEditGroupName] = useState({ visible: false, text: '', id: null })
  const GroupItem = (prop: GroupItemProps) => {
    const { children, id, onClick, activeId, name, status } = prop
    const isActive = id === activeId
    return (
      <GroupItemContainer
        isActive={isActive}
        onClick={() => {
          onClick(id)
        }}
      >
        <div className="text" key={id}>
          <Checkbox
            className="interval"
            onClick={() => {
              if (id && true) toggle(id)
            }}
            checked={isSelected(id)}
            disabled={status === 1}
          />

          <Typography.Text style={{ marginLeft: '10px' }} ellipsis={{ tooltip: children }}>
            {children}
          </Typography.Text>
        </div>
        <>
          <IconFont
            style={{ cursor: 'pointer', marginRight: '10px', fontSize: '16px' }}
            onClick={() => {
              if (status === 1) {
                setTipModal(true)
                return
              }
              form.setFieldsValue({ names: name })
              // selectAgentPool?.pool_id &&
              // setIsEditGroupName({ visible: true, text: children, id: id })
              setShowEditModal({ visible: true, id: id, name: name })
            }}
            type={'icon-huabanfuben'}
            className="delete-icon"
          />

          <IconFont
            type={'icon-shanchu-m'}
            className="delete-icon"
            onClick={() => {
              if (status === 1) {
                setTipModal(true)
                return
              }
              setDeleteModal((deleteModal = { visible: true, deleteId: [id] }))
            }}
          />
        </>
      </GroupItemContainer>
    )
  }
  return (
    <>
      <LeftCard title={t('代理池列表')}>
        <div
          style={{
            width: '288px',
            height: '1px',
            background: '#F8F8F8',
            border: '1px solid #F8F8F8',

            marginTop: '-12px',
            marginBottom: '10px',
          }}
        />

        <SearchGroup>
          <SearchInputTwo
            inputProps={{
              placeholder: t('请输入代理池'),
              value: searchParams.name,
              onChange: e => {
                setSearchParams(origin => ({ ...origin, name: e.target.value }))
              },
            }}
          />
        </SearchGroup>
        <Delete
          isActive={selected.length > 0}
          onClick={() => {
            setDeleteModal(selected?.length > 0 && { visible: true, deleteId: selected })
          }}
        >
          <SvgIcon
            name={selected?.length > 0 ? 'batch_remove' : 'batch_remove_ash'}
            className="icon-delete"
          />

          <span>{t('批量删除')}</span>
        </Delete>
        <GroupListContainer>
          {(agentPoolList || [])?.items?.map(item => (
            <div key={item.pool_id}>
              <GroupItem
                typeId={item?.type_id}
                activeId={selectAgentPool?.pool_id}
                key={item.pool_id}
                name={item.name}
                id={item.pool_id}
                status={item.status}
                onDelete={() => setDeleteModal({ visible: true, deleteId: item.pool_id })}
                onClick={() => {
                  play(item)
                  setSelectAgentPool(item)
                }}
              >
                <Dot status={item.status} />
                {item.name}
              </GroupItem>
            </div>
          ))}
        </GroupListContainer>
        <LeftCardFooter>
          <Button
            type={'primary'}
            style={{ width: '100%' }}
            onClick={() => {
              setShowAddModal(true)
            }}
          >
            {t('添加代理池')}
          </Button>
        </LeftCardFooter>
      </LeftCard>
      <Modal
        title={
          <SignTitle show>
            {showAddModal && <span>{t('添加代理池')}</span>}
            {showEditModal.visible && <span>{t('编辑代理池')}</span>}
          </SignTitle>
        }
        visible={showAddModal || showEditModal.visible}
        onOk={() => {
          form.submit()
        }}
        onCancel={() => {
          form.resetFields()
          setShowAddModal(false)
          setShowEditModal(origin => ({ ...origin, visible: false }))
        }}
        confirmLoading={postAgentPoolLoading}
        centered
      >
        <Form form={form} layout={'vertical'} onFinish={submitHandler}>
          <Form.Item
            name="names"
            rules={[
              { required: true, message: t('请输入代理池名称') },
              {
                validator: async (_, newName) => {
                  if (agentPoolList?.items?.some(group => group.name === newName)) {
                    return Promise.reject(t('代理池名称已存在'))
                  }
                },
              },
              {
                max: 15,
                message: t('代理池名称最多15字'),
              },
              {
                pattern: /^(?=.*\S).+$/,
                message: t('代理池名称不能全部为空格!'),
              },
            ]}
            label={t('代理池名称')}
          >
            <Input placeholder={t('请输入')} />
          </Form.Item>
        </Form>
      </Modal>
      {/*<CustomPayload isEditGroupName={isEditGroupName} exit={exit} />*/}
      <DeleteModal
        text={t('此操作将永久删除，是否继续？')}
        visible={deleteModal.visible}
        onOk={confirmDeleteAgentPool}
        confirmLoading={deleteGrouopLoading}
        onCancel={() => {
          setDeleteModal({ visible: false, deleteId: null })
        }}
      />

      <Modal
        centered
        title={<SignTitle show>{t('提示')}</SignTitle>}
        visible={tipModal}
        footer={[]}
        onCancel={() => setTipModal(false)}
      >
        <Icon type={'icon-tixingshixin'} />
        <span>{t('任务正在使用此代理池，不可编辑或删除')}</span>
      </Modal>
    </>
  )
}
export default ProxyLeft
interface GroupItemContainerProps {
  isActive: boolean
}
const Delete = styled.div<GroupItemContainerProps>`
  width: 76px;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  cursor: ${props => (props.isActive ? 'pointer' : 'no-drop')};
  color: ${props => (props.isActive ? '#333' : '#999')};
  justify-content: center;
  //background-color: #f2f3f5;
  transition: 0.3s;
  margin-bottom: 13px;
  &:hover {
    // background-color: ${props => (props.isActive ? 'rgba(245, 63, 63, 0.1)' : '')};
    .icon-delete {
      width: 12px;
      stroke: ${props => (props.isActive ? '#f53f3f' : '')};
    }
  }
  .icon-delete {
    width: 12px;
    transition: 0.3s;
    height: 12px;
    margin-right: 3px;
  }
`
const GroupItemContainer = styled.div<GroupItemContainerProps>`
  height: 32px;
  border-radius: 4px;
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 4px;
  cursor: pointer;
  background-color: ${props => (props.isActive ? 'rgba(41, 115, 255, 0.1)' : 'transparent')};
  display: flex;
  align-items: center;
  .delete-icon {
    display: none;
    color: #999;
    &:hover {
      color: #2e3d5e;
    }
  }
  .text {
    line-height: 1.5;
    display: flex;
    align-items: center;
    flex-grow: 1;
    width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &:hover {
    background-color: rgba(41, 115, 255, 0.06);
    .delete-icon {
      display: inline-block;
    }
  }
`

const LeftCard = styled(SmallPaddingCard)`
  width: 320px;
  border-radius: 16px;
  margin-right: 16px;
  .ant-card-body {
    display: flex;
    flex-direction: column;

    margin-top: 15px;
    /* height:100% */
    width: 320px;
  }
`

const GroupListContainer = styled(Scrollbars)`
  flex-grow: 1;
  height: 0;
`

const LeftCardFooter = styled.div`
  height: 32px;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`
const SearchGroup = styled.div`
  margin-top: 8px;
  margin-bottom: 16px;
`
interface DotProps {
  status: number
}
const Dot = styled.div<DotProps>`
  display: inline-block;
  margin-right: 4px;
  width: 8px;
  height: 8px;
  border-radius: 8px;
  background: ${props => (props.status === 1 ? '#67C23A' : '#999999')};
`

const Icon = styled(IconFont)`
  color: #faad14;
  font-size: 18px;
  margin-right: 12px;
  transform: translateY(2px);
`
